import React from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    FormControl,
    MenuItem,
    Select,
    TextField,
    Divider,
    CircularProgress
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import ToggleButtonComponent from '../../../../shared/Dashboard/ToogleButton';

// Menu item configurations

const ITR_MODULES = [
    { value: 'piling', label: 'Piling ITR' },
    { value: 'structure', label: 'Structure ITR' },
    { value: 'modules', label: 'Modules ITR' }
];


// Reusable form field component
const FormField = ({ label, width = '50%', children }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography color="text.secondary" fontWeight={500}>
            {label}
        </Typography>
        <Box sx={{ width }}>
            {children}
        </Box>
    </Box>
);

// Reusable select component
const CustomSelect = ({ value, onChange, options, placeholder = "Select an option", ...props }) => (
    <FormControl size="small" fullWidth>
        <Select
            value={value}
            onChange={onChange}
            displayEmpty
            {...props}
        >
            <MenuItem value="" disabled>
                {placeholder}
            </MenuItem>
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

const GenerateNewITRModal = ({
    open,
    onClose,
    formData,
    updateFormField,
    onProceed,
    loading
}) => {
    // Validation helpers
    const isITRValid = () => formData.itrReferenceNumber !== '' && formData.itcModule !== '';

    // Modal content renderer
    const renderModalContent = () => {
        // ITR Modal content
        return (
            <>
                <FormField label="Punchlist Generation">
                    <ToggleButtonComponent
                        data={["internal", "external"]}
                        active={formData.visibility}
                        setActive={(value) => updateFormField('visibility', value)}
                    />
                </FormField>

                <FormField label="ITR Reference Number">
                    <TextField
                        value={formData.itrReferenceNumber}
                        onChange={(e) => updateFormField('itrReferenceNumber', e.target.value)}
                        placeholder="Enter ITR Reference Number"
                        size="small"
                        fullWidth

                    />
                </FormField>

                <FormField label="ITC module">
                    <CustomSelect
                        value={formData.itcModule}
                        onChange={(e) => updateFormField('itcModule', e.target.value)}
                        options={ITR_MODULES}
                    />
                </FormField>
            </>
        );
    };

    // Action buttons
    const renderActionButtons = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        textTransform: 'none',
                        px: 3
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onProceed}
                    disabled={loading || !isITRValid()}
                    startIcon={loading && <CircularProgress size={20} />}
                    sx={{
                        textTransform: 'none',
                        px: 3
                    }}
                >
                    Proceed
                </Button>
            </Box>
        );
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Box sx={{
                width: 600,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
                position: 'relative'
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight={500}>
                        Download ITR
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon sx={{ cursor: "pointer" }} />
                    </IconButton>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {renderModalContent()}

                <Divider sx={{ my: 2 }} />

                {renderActionButtons()}
            </Box>
        </Modal>
    );
};

export default GenerateNewITRModal;